import SolutionTemplate from "./SolutionTemplate";

const TimesheetSolution = () => (
  <SolutionTemplate
    eyebrow="Timesheet management & approval"
    title="Log, approve and report"
    titleGradient="in one flow"
    subtitle="Employees enter daily hours in a weekly grid, admins approve with a click, clients sign off via a secure link, and the weekly summary exports to Excel. Built for staffing agencies and project teams."
    heroImg="/assets/img/hero/Hero_Combine.webp"
    heroImgAlt="TimeTango timesheet management"
    flowSteps={[
      { title: "Log hours", desc: "Employee fills a weekly grid with hours per project" },
      { title: "Admin approves", desc: "Admin reviews and approves or rejects each entry" },
      { title: "Client signs off", desc: "Client approves via a secure token link — no account needed" },
      { title: "Weekly report", desc: "Summary exports to Excel with project and employee breakdown" },
    ]}
    capabilities={[
      { icon: "📅", title: "Weekly grid", desc: "Rows = projects, columns = days, inline hour entry" },
      { icon: "✓", title: "Two-tier approval", desc: "Admin approval + optional client sign-off" },
      { icon: "🔗", title: "Client token link", desc: "Clients approve via secure URL — no login needed" },
      { icon: "📊", title: "Weekly summary", desc: "Collapsible employee → project breakdown report" },
      { icon: "📥", title: "Excel export", desc: "Download detailed or summary reports as .xlsx" },
      { icon: "🏷", title: "Project management", desc: "Create projects, assign to clients, track hours" },
    ]}
    benefits={[
      { title: "Built for staffing", desc: "Contractors log time, agencies approve, clients sign off — all in one flow." },
      { title: "No double-entry", desc: "Hours logged once; flow through approval to report automatically." },
      { title: "Client transparency", desc: "Clients see exactly what they're paying for, no account needed." },
      { title: "Graduated pricing", desc: "Timesheet is included in the base plan — no per-feature add-on." },
    ]}
    relatedSlugs={["/solutions/attendance", "/solutions/leave", "/solutions/activity-tracking"]}
    metaTitle="Timesheet & Approval Software | TimeTango"
    metaDescription="Employee timesheet with weekly grid, admin approval, client sign-off via secure link, and Excel export. Built for staffing agencies and project teams."
  />
);

export default TimesheetSolution;
